import { render, staticRenderFns } from "./ValoracionesPreguntas.vue?vue&type=template&id=327fa509&scoped=true"
import script from "./ValoracionesPreguntas.vue?vue&type=script&lang=js"
export * from "./ValoracionesPreguntas.vue?vue&type=script&lang=js"
import style0 from "./ValoracionesPreguntas.vue?vue&type=style&index=0&id=327fa509&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fa509",
  null
  
)

export default component.exports